import React from "react";
import { InlineIconButton } from "./InlineIconButton";

export const CopyToClipboard: React.FC<{
  text: string;
  label?: string;
}> = ({ text, label }) => {
  const handleClick = () => {
    void navigator.clipboard.writeText(text);
  };

  const paddedLabel = label ? label + " " : "";
  const title = `Copy ${paddedLabel}to clipboard`;

  return (
    <InlineIconButton icon="content_copy" onClick={handleClick} title={title} />
  );
};
